import { Box, Container, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
const AccountDeletedPage = () => {
  return (
    <Box sx={{ backgroundColor: "#161616" }} height={"100vh"}>
      <img
        src="https://precurecdnstorage.blob.core.windows.net/images/Precure_logo_RGB_Hvide_Bogstaver.svg"
        width={250}
        style={{ padding: 20 }}
      />
         <Container maxWidth="sm">
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* Success Icon */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  borderRadius: "50%",
                  backgroundColor: "rgba(34, 197, 94, 0.1)",
                  p: 1.5,
                  display: "inline-flex",
                }}
              >
                <CheckCircleIcon
                  sx={{
                    fontSize: 64,
                    color: "success.main",
                  }}
                />
              </Box>
            </Box>

            {/* Text Content */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                Account has been deleted
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  fontSize: "1.125rem",
                  lineHeight: 1.6,
                }}
              >
                You account has been successfully deleted, we hope you will join us again!
              </Typography>
            </Box>

       
          </Box>
        </Container>
    </Box>
  );
};

export default AccountDeletedPage;
